import { render, staticRenderFns } from "./SessionDetails.vue?vue&type=template&id=04528a3e&scoped=true"
import script from "./SessionDetails.vue?vue&type=script&lang=js"
export * from "./SessionDetails.vue?vue&type=script&lang=js"
import style0 from "./SessionDetails.vue?vue&type=style&index=0&id=04528a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04528a3e",
  null
  
)

export default component.exports